export const TOOLTIPS = {
  appNamespace: 'The folder in which you want to save your data',

  OAuthRedirectUris:
    'The links you would like your users to be redirected to after they login or sign-up.',

  privacyPolicy: 'URL to your privacy policy',
  termsOfUse: 'URL to your terms of use',

  shortDescription: 'A short description of your app when shown in our app store',
  description:
    'A more detailed description of your app to be shown when the app is selected in our app store',
  appPurpose:
    'Please briefly describe the purpose of your application. This will be presented on sign up to users.',
};
